import React from "react";
import { IAppliedCouponCodes, ICouponCard, CouponInfo } from "@swiggy-private/cart-types";
import { CouponCardImpressionPayload } from "@swiggy-private/core-types";
import { GiftingCouponAnalytics } from "@cart-client/components/coupon-listing/types";

interface CouponRendererContextValue {
    paymentOffersRef: React.RefObject<HTMLDivElement>;
    updateGiftingCouponHandler: (payload: CouponCardImpressionPayload) => void;
    couponSelections?: Map<string, boolean>;
    onCouponCheckboxClick?: (couponId: string, businessLine?: string) => void;
    appliedCouponCodes?: IAppliedCouponCodes[];
    isFooterDisabled?: boolean;
    isCouponAvailable?: boolean;
    couponApplied?: boolean;
    coupons?: ICouponCard[] | null;
    isGiftingCouponListing?: boolean;
    isPaymentCouponListingPage: React.MutableRefObject<boolean>;
    handlers: {
        onViewEnter: () => void;
        applyCouponHandler: (payload: CouponCardImpressionPayload) => void;
        showTncCouponHalfcard: (coupon: CouponInfo) => void;
    };
    giftingAnalytics: GiftingCouponAnalytics;
}

export const CouponRendererContext = React.createContext<CouponRendererContextValue>({
    paymentOffersRef: { current: null },
    updateGiftingCouponHandler: () => void 0,
    couponSelections: new Map(),
    onCouponCheckboxClick: () => void 0,
    appliedCouponCodes: [],
    isFooterDisabled: true,
    isCouponAvailable: false,
    couponApplied: false,
    coupons: null,
    isGiftingCouponListing: false,
    isPaymentCouponListingPage: { current: false },
    handlers: {
        onViewEnter: () => void 0,
        applyCouponHandler: () => void 0,
        showTncCouponHalfcard: () => void 0,
    },
    giftingAnalytics: {
        handleImpressionOffers: () => void 0,
        handleCouponOffersImpression: () => void 0,
        handleSelectCouponCheckboxClick: () => void 0,
        handleDeselectCouponCheckboxClick: () => void 0,
        handleApplyCouponImpression: () => void 0,
        handleApplyCouponClick: () => void 0,
        handleSearchBarImpression: () => void 0,
        handleApplyInputBoxClick: () => void 0,
        handleGiftingModalImpression: () => void 0,
        handleGiftingModalCloseClick: () => void 0,
        handleGiftingModalCTAClick: () => void 0,
    },
});
